import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  Slider,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  FormControl,
  Checkbox,
  FormControlLabel,
  Button,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";

const EditBuyerCategoryDialog = ({
  open,
  onClose,
  category,
  paymentOption,
  onUpdate,
  loading,
}) => {
  const [tierName, setTierName] = useState("");
  const [tierColor, setTierColor] = useState("purple");
  const [tierDiscount, setTierDiscount] = useState(0);
  const [includeCash, setIncludeCash] = useState(false);
  const [includeCredit, setIncludeCredit] = useState(false);
  const [cashDiscount, setCashDiscount] = useState("");
  const [creditPeriod, setCreditPeriod] = useState("");
  const [interestRate, setInterestRate] = useState("");
  const [creditLimit, setCreditLimit] = useState("");

  // Initialize form with category data
  useEffect(() => {
    if (category) {
      setTierName(category.name || "");
      setTierColor(category.color || "purple");
      setTierDiscount(Number(category.discount) || 0);
    }

    if (paymentOption) {
      // Set payment options
      setIncludeCash(!!paymentOption.cashPayment);
      setIncludeCredit(!!paymentOption.creditPayment);
      
      // Set cash discount
      if (paymentOption.cashPayment) {
        setCashDiscount(paymentOption.cashPayment.discountPercent?.toString() || "");
      }
      
      // Set credit details
      if (paymentOption.creditPayment) {
        setCreditPeriod(paymentOption.creditPayment.creditPeriodDays?.toString() || "");
        setInterestRate(paymentOption.creditPayment.interestRatePerYear?.toString() || "");
        setCreditLimit(paymentOption.creditPayment.creditLimit?.toString() || "");
      }
    }
  }, [category, paymentOption]);

  const handleSave = () => {
    // Validation
    if (!tierName.trim()) {
      toast.error("Please enter buyer category name");
      return;
    }

    // Prepare payment options
    const paymentOptions = [];

    if (includeCash) {
      // if (
      //   !cashDiscount ||
      //   isNaN(cashDiscount) ||
      //   parseFloat(cashDiscount) < 0
      // ) {
      //   toast.error("Please enter a valid cash discount percentage");
      //   return;
      // }
      paymentOptions.push({
        type: "Cash",
        cashDiscount: parseFloat(cashDiscount),
      });
    }

    if (includeCredit) {
      // if (!creditPeriod || isNaN(creditPeriod) || parseInt(creditPeriod) <= 0) {
      //   toast.error("Please enter a valid credit period");
      //   return;
      // }
      // if (
      //   !interestRate ||
      //   isNaN(interestRate) ||
      //   parseFloat(interestRate) < 0
      // ) {
      //   toast.error("Please enter a valid interest rate");
      //   return;
      // }
      // if (!creditLimit || isNaN(creditLimit) || parseFloat(creditLimit) <= 0) {
      //   toast.error("Please enter a valid credit limit");
      //   return;
      // }

      paymentOptions.push({
        type: "Credit",
        creditPeriod: parseInt(creditPeriod),
        interestRate: parseFloat(interestRate),
        creditLimit: parseFloat(creditLimit),
      });
    }

    // Check if at least one payment option is selected
    // if (paymentOptions.length === 0) {
    //   toast.error("Please select at least one payment option (Cash or Credit)");
    //   return;
    // }

    // Prepare update data
    const updateData = {
      id: category._id,
      categoryData: {
        name: tierName.trim(),
        color: tierColor,
        discount: tierDiscount,
        paymentOptions: paymentOptions.length > 0 ? paymentOptions : null,
      },
    };

    onUpdate(updateData);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3, maxWidth: 1000, width: "100%" },
      }}
    >
      <DialogTitle
        sx={{ fontSize: 28, fontWeight: 700, pb: 3, pt: 4, px: 4 }}
      >
        Edit Buyer Category
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{ position: "absolute", right: 24, top: 24, color: "#9ca3af" }}
      >
        <Close />
      </IconButton>

      <DialogContent sx={{ px: 4, pb: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <div style={{ marginBottom: 8 }}>
              <label
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#6b7280",
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                }}
              >
                Buyer Category Name
              </label>
            </div>
            <TextField
              fullWidth
              value={tierName}
              onChange={(e) => setTierName(e.target.value)}
              placeholder="Enter category name"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "#f9fafb",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <div style={{ marginBottom: 8 }}>
              <label
                style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#6b7280",
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                }}
              >
                COLOR
              </label>
            </div>
            <FormControl fullWidth>
              <Select
                value={tierColor}
                onChange={(e) => setTierColor(e.target.value)}
                sx={{
                  borderRadius: 2,
                  backgroundColor: "#f9fafb",
                }}
              >
                <MenuItem value="purple">Purple</MenuItem>
                <MenuItem value="blue">Blue</MenuItem>
                <MenuItem value="green">Green</MenuItem>
                <MenuItem value="orange">Orange</MenuItem>
                <MenuItem value="red">Red</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Card
          sx={{
            mt: 4,
            backgroundColor: "#f7f9fc",
            boxShadow: "none",
            borderRadius: 3,
            border: "1px solid #e5e7eb",
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 24,
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: 24,
                  fontWeight: 700,
                  color: "#6b7280",
                  letterSpacing: 0.5,
                  textTransform: "uppercase",
                }}
              >
                CATALOG DISCOUNT
              </span>
              <span
                style={{ fontSize: 40, fontWeight: 700, color: "green" }}
              >
                {tierDiscount}%
              </span>
            </div>

            <Slider
              value={tierDiscount}
              onChange={(e, newValue) => setTierDiscount(newValue)}
              min={0}
              max={100}
              sx={{
                color: "green",
                height: 8,
                "& .MuiSlider-thumb": {
                  width: 24,
                  height: 24,
                },
                "& .MuiSlider-track": {
                  height: 8,
                },
                "& .MuiSlider-rail": {
                  height: 8,
                  backgroundColor: "#e5e7eb",
                },
              }}
            />
            <p
              style={{
                fontSize: 14,
                color: "#9ca3af",
                marginTop: 16,
                marginBottom: 0,
              }}
            >
              Applied automatically to MRP for all products.
            </p>
          </CardContent>
        </Card>

        {/* New Section: Payment Options */}
        <div style={{ marginTop: 32 }}>
          <div style={{ marginBottom: 16 }}>
            <label
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: "#0b4064",
                letterSpacing: 0.5,
                textTransform: "uppercase",
              }}
            >
              PAYMENT OPTIONS
            </label>
            <p
              style={{
                fontSize: 12,
                color: "#0b4064",
                marginTop: 4,
                marginBottom: 0,
              }}
            >
              Select at least one payment option
            </p>
          </div>

          <div style={{ display: "flex", gap: 24, marginBottom: 24 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeCash}
                  onChange={(e) => setIncludeCash(e.target.checked)}
                  sx={{
                    color: "#0b4064",
                    "&.Mui-checked": {
                      color: "#0b4064",
                    },
                  }}
                />
              }
              label={
                <span style={{ fontSize: 16, fontWeight: 600 }}>Cash</span>
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeCredit}
                  onChange={(e) => setIncludeCredit(e.target.checked)}
                  sx={{
                    color: "#0b4064",
                    "&.Mui-checked": {
                      color: "#0b4064",
                    },
                  }}
                />
              }
              label={
                <span style={{ fontSize: 16, fontWeight: 600 }}>Credit</span>
              }
            />
          </div>

          {/* Conditional Fields based on selection */}
          <Grid container spacing={3}>
            {/* Cash Discount Field - Show when Cash is selected */}
            {includeCash && (
              <Grid item xs={12} md={6}>
                <div style={{ marginBottom: 8 }}>
                  <label
                    style={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: "#6b7280",
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                    }}
                  >
                    CASH DISCOUNT (%)
                  </label>
                </div>
                <TextField
                  fullWidth
                  value={cashDiscount}
                  onChange={(e) => setCashDiscount(e.target.value)}
                  placeholder="Enter cash discount percentage"
                  type="number"
                  InputProps={{ inputProps: { min: 0, max: 100, step: 0.1 } }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      backgroundColor: "#f9fafb",
                    },
                  }}
                />
              </Grid>
            )}

            {/* Credit Fields - Show when Credit is selected */}
            {includeCredit && (
              <>
                <Grid item xs={12} md={includeCash ? 6 : 4}>
                  <div style={{ marginBottom: 8 }}>
                    <label
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#6b7280",
                        letterSpacing: 0.5,
                        textTransform: "uppercase",
                      }}
                    >
                      CREDIT PERIOD (DAYS)
                    </label>
                  </div>
                  <TextField
                    fullWidth
                    value={creditPeriod}
                    onChange={(e) => setCreditPeriod(e.target.value)}
                    placeholder="e.g., 30"
                    type="number"
                    InputProps={{ inputProps: { min: 1 } }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "#f9fafb",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={includeCash ? 6 : 4}>
                  <div style={{ marginBottom: 8 }}>
                    <label
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#6b7280",
                        letterSpacing: 0.5,
                        textTransform: "uppercase",
                      }}
                    >
                      INTEREST RATE (%)
                    </label>
                  </div>
                  <TextField
                    fullWidth
                    value={interestRate}
                    onChange={(e) => setInterestRate(e.target.value)}
                    placeholder="Annual interest rate"
                    type="number"
                    InputProps={{ inputProps: { min: 0, step: 0.1 } }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "#f9fafb",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={includeCash ? 6 : 4}>
                  <div style={{ marginBottom: 8 }}>
                    <label
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#6b7280",
                        letterSpacing: 0.5,
                        textTransform: "uppercase",
                      }}
                    >
                      CREDIT LIMIT (₹)
                    </label>
                  </div>
                  <TextField
                    fullWidth
                    value={creditLimit}
                    onChange={(e) => setCreditLimit(e.target.value)}
                    placeholder="Maximum credit amount"
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        backgroundColor: "#f9fafb",
                      },
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </div>
      </DialogContent>

      <DialogActions
        sx={{ px: 4, py: 3, gap: 2, justifyContent: "flex-end" }}
      >
        <Button
          onClick={handleClose}
          sx={{
            textTransform: "none",
            fontSize: 16,
            fontWeight: 600,
            color: "#6b7280",
            px: 3,
            py: 1.5,
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={loading}
          sx={{
            backgroundColor: "#0b4064",
            textTransform: "none",
            px: 4,
            py: 1.5,
            fontSize: 16,
            fontWeight: 600,
            borderRadius: 2,
            "&:hover": {
              backgroundColor: "#0b4064",
            },
            "&:disabled": {
              backgroundColor: "#cccccc",
              color: "#666666",
            },
          }}
        >
          {loading ? "Updating..." : "Update Category"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditBuyerCategoryDialog;